
/*

Digistore24 Cart
Version: 1.03
Author: Christian Neise
Documentation: https://help.digistore24.com/hc/
Copyright: Digistore24 GmbH

LICENSE AGREEMENT / TERMS OF USAGE

You may use, modify, use the modified version of this file for the purpose of using
any webshop, billing system, web page, sales page or any other page with the
purpose of selling digital or physical goods with the Digistore24 GmbH.

THIS SOFTWARE IS PROVIDED BY THE REGENTS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES,
INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE REGENTS OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

*/

import { ds24cart_add_exec } from "./lib/functions/cart/ds24cart_add_exec";
import { ds24cart_checkout_exec } from "./lib/functions/cart/ds24cart_checkout";
import { ds24cart_clear_exec } from "./lib/functions/cart/ds24cart_clear";
import { ds24cart_show_exec } from "./lib/functions/cart/ds24cart_show";


//
// You may use these function in your js app
//

// display the cart contents.
// e.g.: <button onclick="return ds24cart_show(this);">Show cart</button>
export function ds24cart_show( button_object_or_id: string|HTMLElement )
{
    return ds24cart_show_exec( button_object_or_id )
}

// add item to cart
// e.g.: <button onclick='return ds24cart_add(12345);'>Add item</button>
export function ds24cart_add( product_id: number, quantity?: number, quantity_readonly?: boolean )
{
    return ds24cart_add_exec( product_id, quantity, quantity_readonly );
}

// remove all items from cart
// e.g.: <button onclick='return ds24cart_clear();'>Remove items</button>
export function ds24cart_clear()
{
    return ds24cart_clear_exec();
}

export function ds24cart_checkout() {
    return ds24cart_checkout_exec();
}

window.DS24_HOVER_DISABLED         = false;
window.ds24cart_wait_timeout_handler = false;

export * from './lib/functions/cart/ds24cart_loader';
export { ds24cart_callback_checkout } from "./lib/functions/cart/ds24cart_checkout";
export { ds24cart_callback_set } from "./lib/functions/cart/ds24cart_quantity";
export { ds24cart_callback_clear } from "./lib/functions/cart/ds24cart_clear";
export { ds24cart_callback_show } from "./lib/functions/cart/ds24cart_show";
export * from './lib/functions/cart/ds24cart_activate_buttons';
